import { render, staticRenderFns } from "./KonvaViewerPopover.vue?vue&type=template&id=db610fac&scoped=true"
import script from "./KonvaViewerPopover.vue?vue&type=script&lang=js"
export * from "./KonvaViewerPopover.vue?vue&type=script&lang=js"
import style0 from "./KonvaViewerPopover.vue?vue&type=style&index=0&id=db610fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db610fac",
  null
  
)

export default component.exports